import { GetBannerToneDto, GetBannerToneDtoImpl } from './getbannertonedto';
import { DecodeHTMLEntities } from '../../../utils/decodehtmlentities';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { BaseContext } from '../../../utils/basecontext';
import { DateFormat } from '../../../ui/toolkit/dateformat/dateformat';

export class GetBannerBuilder {
    constructor(private getBannerList: any, private context: BaseContext) {
        if(getBannerList.bannerDetailsList === undefined)
        {
            throw new NoDataException("Get Banner data doesnt exists");
        }
    }

    buildAll(): GetBannerToneDto[] {
        return this.parseGetBannerDetailsResponse();
    }

    private parseGetBannerDetailsResponse(): GetBannerToneDto[] {
        let decodeEntities = new DecodeHTMLEntities();
        let listOfGetBanner: GetBannerToneDto[] = [];
        let getbannerDto: GetBannerToneDtoImpl;

        this.getBannerList.bannerDetailsList.forEach((bannerDetailsItem: any) => {
            getbannerDto = new GetBannerToneDtoImpl();

            getbannerDto.setId(bannerDetailsItem.contentId);
            getbannerDto.setContentId(bannerDetailsItem.contentId);
            getbannerDto.setToneName(decodeEntities.decodeHTMLEntities(bannerDetailsItem.contentName));
            getbannerDto.setToneUrl(this.context.getConfigurationSettings().getProperty("WISHLIST_TONE_URL") + bannerDetailsItem.path);
            getbannerDto.setImgPath(this.context.getConfigurationSettings().getProperty("WISHLIST_IMAGE_URL") + bannerDetailsItem.previewImage);
            getbannerDto.setAlbumName(bannerDetailsItem.album);
            getbannerDto.setArtistName(decodeEntities.decodeHTMLEntities(bannerDetailsItem.artist));
            getbannerDto.setTuneType(bannerDetailsItem.tuneType);
            getbannerDto.setBannerOrder(bannerDetailsItem.bannerOrder);
            getbannerDto.setExpirydate(DateFormat.formatExpiryDate(bannerDetailsItem.expiryDate, this.context));
            listOfGetBanner.push(getbannerDto);
        });
        return listOfGetBanner;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getbannerdetails/getbannerbuilder.ts